import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../components/Button";
import { Logo } from "../../components/Logo";
import * as S from "./styles";
import { colors } from "../../../../styles/themes/default/foundations/colors";
import useRecoveryPassword from "../../../../hooks/useRecoveryPassword";
import { useEffect, useState } from "react";
import { toastify } from "../../../../shared/Toastify";
import { AxiosError } from "axios";

export function LinkExpired() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const countryCode = searchParams.get("countryCode");
  const { resendEmail } = useRecoveryPassword();
  const [secondsLeft, setSecondsLeft] = useState(60);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (secondsLeft <= 0) return;

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  async function handleResendEmail() {
    if (!email || !countryCode || secondsLeft > 0) return;

    setIsLoading(true);

    try {
      await resendEmail(email, countryCode);

      setSecondsLeft(60);
    } catch (error) {
      let message = t("failedToResendEmail");

      if (error instanceof AxiosError) {
        message = error?.response?.data?.message || t("failedToResendEmail");
      }

      toastify("error", message, "top-right");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <S.LinkExpiredContainer>
      <S.LinkExpiredContent>
        <Logo />

        <S.LinkExpiredTitle>{t("linkExpiredTitle")}</S.LinkExpiredTitle>

        <S.LinkExpiredDescription>
          {t("linkExpiredDescription")}
        </S.LinkExpiredDescription>

        <S.ButtonContainer>
          <Button
            type="button"
            style={{ width: "100%" }}
            isLoading={isLoading}
            disabled={secondsLeft > 0 || isLoading}
            onClick={handleResendEmail}
          >
            <p>
              {secondsLeft > 0
                ? t("resendEmailWithTimer", { seconds: secondsLeft })
                : t("resendEmail")}
            </p>
          </Button>
          <h4>{t("returnToSignIn")}</h4>

          <Button
            type="button"
            onClick={() => navigate(`/signin?email=${email}`)}
            style={{
              width: "100%",
              backgroundColor: colors.white,
              color: colors["black-900"],
            }}
          >
            <p>{t("backToLogin")}</p>
          </Button>
        </S.ButtonContainer>
      </S.LinkExpiredContent>
    </S.LinkExpiredContainer>
  );
}
